module.exports = __webpack_public_path__ + "img/wayanadLogo.f051ae44.png";